import patientdashboardimg from "../../media/image.jpg";
import "../../App.css";
import "./CustomerSidebar.css";
import "./Sidebar.css";
import { useStateValue } from "../../Component/StateProviders";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
export default function CustomerSidebar() {
  let navigate = useNavigate();

  const [userdata, setuserdata] = useState({});
  const [{ IsLogin, IsRegister }, dispatch] = useStateValue();
  const calculateAge = (birthdate) => {
    const birthDate = new Date(birthdate);
    const today = new Date();

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();

    if (months < 0 || (months === 0 && today.getDate() < birthDate.getDate())) {
      years--;
      months += 12;
    }

    if (today.getDate() < birthDate.getDate()) {
      months--;
    }

    return `${years} years`;
  };  
  useEffect(() => {
    console.log(">>>Header  IsLogin");
    // dispatch({ type: 'Register' })

    // if (!IsLogin) {
    var Url = window.API_PREFIX + "patient/check_user";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data["status"] === "1") {
          dispatch({ type: "Login" });

          setuserdata({ ...data });
        } else {
          // navigate('/login')
        }
        console.log(IsLogin);
        console.log(IsRegister);
      });
    // }
  }, [IsLogin]);

  console.log(userdata);

  return (
    // Asidetag-start
    <aside className="sidebar_main_division">
      <div className="User_detail_main_div mt-2 mb-2">
        <div className="profile_info">
          <div className="profile_info_img_div">
            <img src={userdata["Img"]}></img>
          </div>
        </div>
        <h4>{userdata["Name"]}</h4>
        <div className="d-flex justify-content-center align-items-center">
          <span style={{ textTransform: "capitalize" }}>{userdata.Gender}</span>
          <i
            class="fa-solid fa-circle"
            style={{ color: "#743A87", fontSize: "6px", margin: "0px 2px" }}
          ></i>
          <span>{calculateAge(userdata.Birthdate)}</span>
        </div>
      </div>

      <div
        className={
          window.location.pathname.includes("/dashboard")
            ? "sidebar_dashboard_title_division_active"
            : "sidebar_dashboard_title_division"
        }
        onClick={() => {
          navigate("/dashboard");
        }}
      >
        <i class="fa-solid fa-shapes me-2"></i> Dashboard
      </div>
      <div
        className={
          window.location.pathname.includes("/booking")
            ? "sidebar_dashboard_title_division_active"
            : "sidebar_dashboard_title_division"
        }
        onClick={() => {
          navigate("/booking");
        }}
      >
        <i class="fa-solid fa-calendar-days me-2"></i> Book Appointment
      </div>

      <div
        className={
          window.location.pathname.includes("/profile-setting")
            ? "sidebar_dashboard_title_division_active"
            : "sidebar_dashboard_title_division"
        }
        onClick={() => {
          navigate("/profile-setting");
        }}
      >
        <i class="fa-solid fa-user-pen me-2"></i> Profile Settings
      </div>
      <div
        className={
          window.location.pathname.includes("/change-password")
            ? "sidebar_dashboard_title_division_active"
            : "sidebar_dashboard_title_division"
        }
        onClick={() => {
          navigate("/change-password");
        }}
      >
        <i class="fa-solid fa-key me-2"></i> Change Password{" "}
      </div>
      <div
        className="sidebar_dashboard_title_division"
        onClick={() => {
          localStorage.clear();
          dispatch({
            type: "Logout",
          });
          navigate("");
        }}
      >
        <i class="fa-solid fa-right-from-bracket me-2"></i> Logout{" "}
      </div>
    </aside>
    // Asidetag-end
  );
}
